"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HelperUtils_1 = require("src/utils/HelperUtils");
const SVGIcon_1 = __importDefault(require("./SVGIcon"));
const TooltipContainer_1 = __importDefault(require("./Tooltips/TooltipContainer"));
// enum still cant use constant so it still using hardcode string not CALC_TYPE_ZERO_TARGET etc. https://github.com/microsoft/TypeScript/issues/40793
const calcultaionTypes = {
    normal: 'normal',
    lessIsBetter: 'less_is_better',
    zeroTarget: 'zero_target',
    earlyCompletion: 'early_completion'
};
const typeProps = [
    {
        id: calcultaionTypes.earlyCompletion,
        text: 'Early Completion',
        iconName: 'icon-early-completion',
        dataCy: 'early-completion-icon'
    },
    {
        id: calcultaionTypes.lessIsBetter,
        text: 'Less Is Better',
        iconName: 'icon-trending_down',
        dataCy: 'less-is-icon'
    },
    {
        id: calcultaionTypes.zeroTarget,
        text: 'Zero Target',
        iconName: 'icon-center_focus_number',
        dataCy: 'zero-target-icon'
    }
];
const CalculationTypeIndicator = ({ calculationType, showText = false, bgColorClass = 'bg-b-100', customClass, cySuffix }) => {
    const typeProp = typeProps.find(({ id }) => id == calculationType);
    if (calculationType == calcultaionTypes.normal || !typeProp) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return (react_1.default.createElement(TooltipContainer_1.default, { show: !showText, text: (0, HelperUtils_1.getObjectiveLocale)(typeProp.text), classContainer: `${bgColorClass} ${showText ? 'px-[8px]' : 'px-[2px]'} rounded-[4px] h-[20px] w-fit flex items-center justify-center ${customClass ? customClass : ''}`, dataCy: typeProp.dataCy + (cySuffix ? '-' + cySuffix : '') },
        react_1.default.createElement(SVGIcon_1.default, { size: 16, fillColor: "var(--b-600)", iconName: typeProp.iconName }),
        showText && (react_1.default.createElement("p", { className: "text-b-800 typography-h100 ml-[4px]" }, (0, HelperUtils_1.getObjectiveLocale)(typeProp.text)))));
};
exports.default = CalculationTypeIndicator;
